import { render } from "./Spreadsheet.vue?vue&type=template&id=5d9590b0&scoped=true"
import script from "./Spreadsheet.vue?vue&type=script&lang=js"
export * from "./Spreadsheet.vue?vue&type=script&lang=js"

import "./Spreadsheet.vue?vue&type=style&index=0&id=5d9590b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9590b0"]])

export default __exports__